import CrudService from '../core/crud-service';

export default class GroupService extends CrudService {
  static override route = 'group';
}
